import type { PubSub } from '../../PubSub';
import type { GameEvents } from '../../events';

/** Publishes `game:restart` to trigger a full game reset to level 1. */
export class RestartGame {
    execute(pubsub: PubSub<GameEvents>, flag: { cancelled: boolean }): Promise<void> {
        return new Promise((resolve) => {
            if (flag.cancelled) { resolve(); return; }
            pubsub.publish('game:restart');
            resolve();
        });
    }
}
